import AdminLayout from "./Components/AdminLayout";

export default function AdminDashboard() {

    const user = JSON.parse(
        localStorage.getItem('authUser') ||
        sessionStorage.getItem('authUser') ||
        '{}'
    );

    return (
        <AdminLayout>

            <div className="admin-welcome-card">

                <h1>
                    Welcome, {user.name}
                </h1>

                <p>
                    You are logged into the CMS.
                </p>

            </div>

        </AdminLayout>
    );
}
